import React, {useEffect, useState} from 'react';
import LanguageButtonDPC from "./dpc-language-button-italert";
import LogoSVG from "../../img/dpc.logo.sprite.svg";
import NavbarDPC from "./dpc-navbar";
import SvgIconDPC from "../dpc-svg-icon";
import {buildMenu} from "../../js/shared-functions";
import Marquee from "react-fast-marquee";
import GoogleAnalytics from './dpc-googleAnalytics';


export default ({slugTraduzione, menuItems, env, lang, basePathNavbar, contenutoId, minisiti, subdomain}) => {

    const [strillo, setStrillo] = useState(null);

    const showStrillo = strillo && Object.keys(strillo).filter(chiave =>
        chiave.includes("it-alert") && strillo[chiave].active === "true").length > 0

    function getStrillo() {
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function () {
            if (this.readyState === 4 && this.status === 200 && this.responseText) {
                var obj = this.responseText;
                try {
                    var obj1 = JSON.parse(obj);
                    setStrillo(obj1);
                } catch (e) {
                    console.log('Strillo non presente')
                }
            }
        };

        xhttp.open("GET", 'https://dpc-it-alert-headline.s3.eu-south-1.amazonaws.com/dpc-it-alert-headlines.json', true);
        xhttp.send();

        /*let response = await fetch('../strillo.it.json', {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        }).catch(() => console.log('Strillo non presente'));
  
        if (response.ok) {
            let json = await response.json();
            setStrillo(json);
        }*/
    }


    useEffect(() => {
        getStrillo();
    }, []);


    function getMenu(menuItems) {
        return subdomain
            ? buildMenu(menuItems, lang, env, basePathNavbar, contenutoId, minisiti)
            : buildMenu(menuItems, lang, env, null, contenutoId, minisiti)
    };

    function getHomePath() {
        if (subdomain) {
            return `${basePathNavbar}/${lang}/`
        } else {
            return `/${lang}/`
        }
    }


    /*if(this.state.redirect){
        if(typeof window !== `undefined`){
            let url = this.props.basePathNavbar
                ? new URL(this.props.basePathNavbar + '/risultati-ricerca')
                : new URL(window.location.origin + `/${this.props.lang}/risultati_ricerca`);
            url.search = `search=${this.state.value}`;
            window.location.href = url;
        }
    }*/
    return (
        <header
            className={`it-header-wrapper it-header-sticky it-shadow`}
            role="banner"
            id={"header-dpc"}>
            <GoogleAnalytics trackingId="G-JF95DP4KV9" />
            <LanguageButtonDPC slugTraduzione={slugTraduzione} env={env}
                               lang={lang}/>
            <div className="it-nav-wrapper">
                <div className="it-header-center-wrapper">
                    <div className="container">
                        <div className="it-header-center-content-wrapper">
                            <div className="it-brand-wrapper">
                                <ul className="list-inline">
                                    <li className="list-inline-item">
                                        <a href={getHomePath()}
                                           className="navbar-brand">
                                            <svg className="icon it-alert-logo-colore">
                                                <use xlinkHref={`${LogoSVG}#dpc.it-alert.logo-colore`}/>
                                            </svg>
                                        </a>
                                    </li>
                                </ul>
                                <div>
                                    <h2>
                                        <a href={getHomePath()}
                                           title="IT-alert">
                                            IT-alert <small class="badge-beta">test</small>
                                        </a>


                                    </h2>
                                    <h3>{lang === 'it' ? 'Sistema nazionale di allarme pubblico' : 'National public warning system'}</h3>
                                </div>
                            </div>
                            <div className="it-right-zone">
                                <div className="it-socials d-none d-xl-flex">
                                    <span>{lang === 'it' ? 'Seguici su' : 'Follow us'}</span>
                                    <ul>
                                        <li>
                                            <a href="https://www.facebook.com/ITALERTgov"
                                               title="Pagina Facebook di IT Alert"
                                               target="_blank" rel="noreferrer">
                                                <SvgIconDPC name={'facebook'}/>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://twitter.com/italertgov?s=11&t=ahRqmffJIm58O5MOcSPDFQ"
                                               title="Segui IT Alert su Twitter"
                                               target="_blank" rel="noreferrer">
                                                <SvgIconDPC name={'twitter'}/>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://www.youtube.com/@ITALERTgov"
                                               title="Canale YouTube di IT Alert"
                                               target="_blank" rel="noreferrer">
                                                <SvgIconDPC name={'youtube'}/>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://instagram.com/italertgov?igshid=ZWQyN2ExYTkwZQ=="
                                               title="Profilo di IT Alert su Instagram"
                                               target="_blank" rel="noreferrer">
                                                <SvgIconDPC name={'instagram'}/>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                {showStrillo &&
                    <div class="it-header-strillo">
                        <div class="container">
                            <div class="it-strillo-wrapper">
                                <div class="px-custom">
                                    {/*<div class="marquee">
                                        {/*strillo.messaggi.map(messaggio =>
                                            <>                                           
                                                <div class= {`message ${messaggio.stato? "allerta-" + messaggio.stato.toLowerCase():""}`}>
                                                    <a href={messaggio.link}><span class="sr-only">Allerta {messaggio.stato}</span>{messaggio.titolo}</a></div>
                                            </>
                                        )*/
                                        /*strillo.messaggi.map(messaggio =>                                                       
                                                <div class= {`message`}>
                                                    {messaggio.titolo}</div>
                                            
                                        )

                                        }

                                    </div>*/}
                                    <Marquee gradient={false} delay={2} speed={90} direction={'left'}
                                             pauseOnHover={true} className='marquee'>
                                        {Object.keys(strillo).map(chiave => {
                                            if (chiave.includes("it-alert") && strillo[chiave].active === "true") {
                                                return (
                                                    <div className={`message`}
                                                         style={{"background-color": `${strillo[chiave].color}`}}>
                                                        <a href={strillo[chiave].link[lang]}><span
                                                            class="sr-only">{lang === 'it' ? 'Allerta ' : 'Alert '}</span>{strillo[chiave].message[lang]}</a>
                                                    </div>
                                                )
                                            }
                                        })}
                                    </Marquee>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                <NavbarDPC menuItems={getMenu(menuItems)} lang={lang} isItAlert={true}/>
                {/*<SubNavbarDPC
                        menuItems={buildMenu(this.props.subdomainMenuItems, this.props.lang, this.props.env, null, this.props.contenutoId)}/>*/}
            </div>
        </header>)

};
